<template>
  <div class="Header">
    <div class="nav-top">
      <div class="main-1200-width">
        <div class="left">欢迎进入{{appInfo.name}}！专业不止于此，请相信我们！</div>
        <div class="right">
          <span class="nav-link" role="link" tabindex="0" @click="toMyOrder"><span class="el-icon el-icon-s-order"></span>我的订单</span>
          <a href="/ShoppingCar" :class="{ 'cart-flash': cartFlash }"><span class="el-icon el-icon-shopping-cart-2"></span>
            购物车
            <span v-if="cartNum">（<span>{{cartNum}}</span>）</span></a>
          <div class="my-info" v-if="is_login">
            <span class="nav-link" role="link" tabindex="0" @click="toPersonal"><span class="el-icon el-icon-user"></span><span>{{userInfo.mobile}}</span></span>
            <div class="logout" @click="logout">退出登录</div>
          </div>
          <span v-else class="nav-link" role="link" tabindex="0" @click="toLogin"><span class="el-icon el-icon-user"></span><span>个人中心</span></span>
        </div>
      </div>
    </div>
    <div class="nav-main main-1200-width">
      <a href="/" class="logo">
        <img :src="$url.cdn(appInfo.logo)" :alt="appInfo.name"/>
        <span class="fg">|</span>
        <span>{{appInfo.name}}</span>
      </a>
      <div class="search-main">
        <div class="search-line1">
          <input type="text" placeholder="搜索关键字" v-model="keywords" @keyup="searchText" @keyup.enter="search"/>
          <div class="search" @click="search"><span class="el-icon el-icon-search"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import { getStore } from '@/units/store'
  import { MessageBox } from 'element-ui'
  export default {
    data() {
      return {
        cateData : [],
        linksData: [],
        cartNum  : false,
        cartFlash: false,
        keywords : this.$route.query['search']
      };
    },
    computed: {
      ...mapGetters(['is_login', 'appInfo', 'userInfo']),
    },
    created() {
      this.keywords = this.$route.params.search;
      this.getCartNum();
    },
    methods: {
      searchText(e) {
        this.keywords = e.target.value;
      },
      search() {
        if (this.$parent.searchClick) {
          this.$parent.searchClick(this.keywords);
        } else {
          this.$router.push({
            path: 'Search',
            name: 'Search',
            params: {
              search: this.keywords,
            }
          });
        }
      },
      async getCartNum() {
        if (!this.is_login) return
        try {
          await this.$store.dispatch('cart/getList')
          this.cartNum = this.$store.state.cart.list.length
        } catch (e) {
          this.cartNum = false
        }
      },
      flashCart() {
        this.cartFlash = true
        setTimeout(() => {
          this.cartFlash = false
        }, 900)
      },
      async logout() {
        await this.$store.dispatch('user/Logout')
        this.$message({
          type: "success",
          message: "注销成功"
        });
        const redirect = this.$route && this.$route.fullPath ? this.$route.fullPath : '/'
        this.$router.push({ name: 'Login', query: { redirect } })
      },
      toLogin() {
        const redirect = this.$route && this.$route.fullPath ? this.$route.fullPath : '/'
        this.$router.push({ name: 'Login', query: { redirect } })
      },
      toPersonal() {
        // 已登录才会展示该入口
        this.$router.push({ path: '/PerSonalLayout/PerSonalInfo' })
      },
      toMyOrder() {
        if (this.is_login) {
          this.$router.push({ path: '/PerSonalLayout/MyOrder' })
          return
        }
        const redirect = '/PerSonalLayout/MyOrder'
        let jumped = false
        const timer = setTimeout(() => {
          jumped = true
          this.$router.push({ name: 'Login', query: { redirect } })
        }, 3000)
        MessageBox.alert('请登录后查看订单，3秒后将自动跳转到登录页。', '提示', {
          confirmButtonText: '立即登录',
          showClose: false,
          type: 'warning',
          callback: () => {
            if (!jumped) {
              clearTimeout(timer)
              this.$router.push({ name: 'Login', query: { redirect } })
            }
          }
        }).catch(() => {})
      }
    },
  };
</script>
<style lang="less" scoped>
  .Header {
    width: 100%;
    min-width: 1200px;
    background: #FFFFFF;
    border-bottom: 1px solid #D2D2D2;
  }

  .nav-top {
    width: 100%;
    min-width: 1200px;
    font-size: 12px;
    height: 48px;
    color: #FFFFFF;
    display: flex;
    background: #333333;
    align-items: center;
    justify-content: space-around;

    a {
      color: rgb(143, 143, 143);
    }

    .main-1200-width {
      padding: 0 15px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .right {
        height: 100%;
        display: flex;

        a, .nav-link {
          color: #FFFFFF;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 20px;
          cursor: pointer;

          span.el-icon {
            font-size: 18px;
            margin-right: 8px;
          }
        }

        a.active, a:hover {
          background: #7B7A7A;
        }

        .my-info {
          position: relative;

          .logout {
            left: 0;
            top: 48px;
            height: 0;
            opacity: 0;
            width: 100%;
            color: #333333;
            cursor: pointer;
            font-size: 12px;
            line-height: 36px;
            position: absolute;
            text-align: center;
            background: #FFFFFF;
            transition: all 0.15s;
            border: 1px solid #333333;
            border-top: none;
            overflow: hidden;
          }
        }

        .my-info:hover {
          .logout {
            height: 36px;
            opacity: 1;
          }
        }

        @keyframes cartFlashShake {
          0% { transform: translateX(0); background: rgba(202, 20, 29, 0.0); }
          15% { transform: translateX(-2px); background: rgba(202, 20, 29, 0.15); }
          30% { transform: translateX(2px); background: rgba(202, 20, 29, 0.25); }
          45% { transform: translateX(-2px); background: rgba(202, 20, 29, 0.18); }
          60% { transform: translateX(2px); background: rgba(202, 20, 29, 0.12); }
          100% { transform: translateX(0); background: rgba(202, 20, 29, 0.0); }
        }

        .cart-flash {
          border-radius: 6px;
          animation: cartFlashShake 0.9s ease-in-out;
        }
      }
    }
  }

  .nav-main {
    height: 96px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      color: #333333;
      display: flex;
      align-items: center;

      img {
        height: 49px;
        object-fit: contain;
      }

      span {
        font-size: 24px;
      }

      span.fg {
        margin: 0 15px;
      }
    }
  }

  .search-line1 {
    display: flex;

    input {
      width: 250px;
      height: 50px;
      background-color: #ffffff;
      border: 1px solid #E0E0E0;
      text-indent: 20px;
      font-size: 14px;
    }

    div {
      display: flex;
      justify-content: center;
      cursor: pointer;
      align-items: center;
    }

    .search {
      width: 80px;
      height: 50px;
      background: #FFFFFF;
      border: 1px solid #E0E0E0;
      border-left: none;
      color: #666666;
      font-size: 18px;

      .el-icon {
        font-weight: bold;
      }
    }

    .whiteButton {
      width: 101px;
      height: 31px;
      background-color: #ffffff;
      border: solid 1px #e5e5e5;
    }

    .l {
      margin-left: 7px;
      border-right: none;
    }
  }

  .search-line2 {
    color: #666666;
    font-size: 14px;
  }
</style>
